import React from "react";
import LoanManagment from "./LoanManagment";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DigitalWallet from "./DigitalWallet";
import classes from "./MoobiVault.module.scss";
import Header from "../../components/Header/Header";
import BusinessContainer from "./BusinessContainer";
import Footer from "../../components/Footer/Footer";
import PromoBanner from "../../components/PromoBanner/PromoBanner";
import MoobiBanners from "../../components/MoobiBanners/MoobiBanners";
import MobiVaultLogo from "../../assets/MoobiVaultImages/MoobiVault_Logo_icon.png";
import MobiVaultName from "../../assets/MoobiVaultImages/MoobiVaultName_Logo.svg";
import firstImage from "../../assets/MoobiVaultImages/1.jpg";
import secondImage from "../../assets/MoobiVaultImages/2.jpg";
import thirdImage from "../../assets/MoobiVaultImages/3.jpg";
import fourthImage from "../../assets/MoobiVaultImages/4.jpg";
import fifthImage from "../../assets/MoobiVaultImages/5.jpg";
import CaroselComponent from "./CaroselComponent";



function MoobiVault() {
  const images = [firstImage, secondImage, thirdImage, fourthImage, fifthImage].filter(Boolean);

  const TitlesPnbl = [
    "Streamlined Loan Management",
    "Enhanced Customer Experience",
    "Expanded Customer Base",
    "Data-driven Credit Decisioning",
    "Enhanced Customer Loyalty",
    "Increased Revenue Opportunity",
    "Improved Risk Assessment",
    "Customizable Financing Options",
    "Efficient Collection Process"
  ];


  return (
    <>
      <Header />
      <MoobiBanners logoName={MobiVaultName} LogoIcon={MobiVaultLogo} style="MobiVault" />
      <div className="container">
        <div className={classes.titleMoobiVault}>
          <span className={classes.firstTitle}>
            Over<span className={classes.secondTitle}>view</span>
          </span>
          <p className={classes.paragraphStyle}>
            Moobitek is a Fintech Powerhouse. Our cutting-edge platforms deliver
            innovative financing and lending solutions, tailored to keep financial
            institutions and businesses ahead of the curve. Experience the future
            of fintech with Moobitek.
          </p>
        </div>
      </div>
      <LoanManagment />
      <div className={classes.businessContainerTitles}>
        <div className={classes.firstInfoPnPl}>
          <span className={classes.businessTitle}>
            Buy Now<span className={classes.businessTitleSecond}> Pay Later</span>
          </span>
          <p className={classes.businessParagraph}>
            Enhance your business with our Buy Now, Pay Later technology that
            service ecommerce and in store financing. Offer flexible payment
            options, boost sales, and elevate the customer experience with
            real-time approvals and secure, automated payment plans.
          </p>
          {TitlesPnbl.map((title, index) => (
            <div key={index} className={classes.bnPlPoints}>
              <div className={classes.dotTitlePositionPnbl}>
                <div className={classes.pointsStyle} />
                <span className={classes.bnplTitle}>{title}</span>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.secondInfoPnPl}>
          <CaroselComponent images={images} arrowsPnPl="arrowsPnPl" length={5} Bnpl="Bnpl" />
        </div>
      </div>
      <DigitalWallet />
      <Footer whiteVersion="white" />
    </>
  );
}

export default MoobiVault;
